import * as React from 'react'
import { ReactElement, useMemo } from 'react'
import useUnits from '../../../hooks/useUnits'
import { AccountingId } from '../../../config/finance/invoiceConfig'
import EntityField from './EntityField'
import { EntityLabelType } from './EntityLabel'
import DimensionFields, { DimensionFieldTuple, DimensionsDto } from './DimensionFields'

type Props = {
    values: DimensionsDto
    setValue: (property: keyof DimensionsDto, item: AccountingId) => void
    unitKey: string
}

export default function SingleUnitDimensionFields({ values, setValue, unitKey }: Props): ReactElement {
    const { units } = useUnits()
    const unit = useMemo(() => (units || []).find(unit => unit.key === unitKey), [units, unitKey])

    if (!unit) {
        return <></>
    }

    return (
        <DimensionFields unit={unit}>
            {([dimension, property]: DimensionFieldTuple) => (
                <EntityField
                    key={`accounting-${unit.key}-${dimension}`}
                    unit={unit}
                    labelType={EntityLabelType.None}
                    externalType={dimension}
                    value={values?.[property]}
                    setFieldValue={(item: AccountingId) => setValue(property, item)}
                />
            )}
        </DimensionFields>
    )
}
